module.exports = __webpack_public_path__ + "static/media/Line-Up_Review_Paciente_5.f7c1e550.jpeg";